style= require('./confirmation-screen.styl')

.sc-dash-row
  sporty-sc-validator(match=match)
  .field.entries
    .title
      sporty-status(
        match=match,
        edit,
        viewDashboard,
        (toggle-bop)= changeFilterBOP(e)
      )
      sporty-events(match=match, validity, filterBop=filterBop, context='confirmations')
      .edit-stats
        each team in match.teams
          if batches && batches.length > 1
            .em= team.name
              each batch in batches
                .em= 'Batch ' + batch
                sporty-stats(
                  match=match,
                  team=team,
                  edit-mode=team.editStats,
                  context='confirmations',
                  batch=batch,
                )
      if batches && batches.length > 1
        ft-button(
          (click)= saveStats(),
        )='Save Confirmed Lineups'
